import { render, staticRenderFns } from "./Universe.vue?vue&type=template&id=72295dba&scoped=true&"
import script from "./Universe.vue?vue&type=script&lang=js&"
export * from "./Universe.vue?vue&type=script&lang=js&"
import style0 from "./Universe.vue?vue&type=style&index=0&id=72295dba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72295dba",
  null
  
)

export default component.exports